<template>
  <div class="supportH5" ref="supportH5">
    <!-- Hero Banner -->
    <div class="hero-section">
      <img class="hero-bg" v-lazy="require('@/assets/help/h5-hero-bg-6d0c75.png')" alt="" />
      <!-- <div class="hero-content">
        <h1 class="hero-title">客户与支持服务</h1>
        <p class="hero-subtitle">为商户提供稳定、安全、持续的技术支持服务</p>
        <div class="hero-features">
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>7x12小时响应</span>
          </div>
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>专业技术团队</span>
          </div>
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>全流程售后保障</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- 我的服务能力 -->
    <div class="section service-section">
      <div class="section-header">
        <h2 class="section-title">我们的服务能力</h2>
        <p class="section-desc">提供多场景解决方案，满足各行业客户的业务需求，<br />快速实现数字化转型</p>
      </div>
      <div class="service-grid">
        <div class="service-card" v-for="item in serviceList" :key="item.title">
          <img class="service-icon" v-lazy="item.icon" alt="" />
          <div class="service-info">
            <h3 class="service-title">{{ item.title }}</h3>
            <p class="service-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 多种支持方式 -->
    <div class="section support-section">
      <div class="section-header">
        <h2 class="section-title">多种支持方式，快速为您解决问题</h2>
      </div>
      <div class="support-cards">
        <div class="support-card wechat-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-wechat.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title green">在线客服</h3>
            <p class="support-desc">实时在线沟通，快速响应<br />微信/企微客服，方便快捷</p>
            <div class="support-btn green-btn">立即咨询</div>
          </div>
        </div>
        <div class="support-card ticket-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-ticket.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title purple">提交工单</h3>
            <p class="support-desc">详细描述问题，专人跟进<br />问题跟踪处理，进度可查</p>
            <span class="support-tag purple-tag">代理商专属</span>
          </div>
        </div>
        <div class="support-card phone-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-phone-support.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title blue">电话支持</h3>
            <p class="support-desc">电话一对一服务，专业高效<br />工作时间：<br />9:00 - 21:00</p>
            <span class="support-tag blue-tag">400-086-1123</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务流程 -->
    <div class="section flow-section">
      <div class="section-header">
        <h2 class="section-title">服务流程</h2>
      </div>
      <div class="flow-steps">
        <template v-for="(step, index) in flowSteps">
          <div class="flow-step" :key="'step-' + step.num">
            <img class="step-icon" v-lazy="step.icon" alt="" />
            <span class="step-title">{{ step.title }}</span>
          </div>
          <img
            v-if="index < flowSteps.length - 1"
            :key="'arrow-' + step.num"
            class="step-arrow"
            v-lazy="require('@/assets/help/h5-step-arrow.svg')"
            alt=""
          />
        </template>
      </div>
    </div>

    <!-- 服务保障 -->
    <div class="section guarantee-section">
      <div class="section-header">
        <h2 class="section-title">服务保障</h2>
        <p class="section-desc">数十年的行业服务经营，做商家服务领域最值得信赖的伙伴</p>
      </div>
      <div class="guarantee-grid">
        <div class="guarantee-card" v-for="item in guaranteeList" :key="item.value">
          <div class="guarantee-head">
            <img class="guarantee-icon" v-lazy="item.icon" alt="" />
            <span class="guarantee-value">{{ item.value }}</span>
          </div>
          <div class="guarantee-label">{{ item.label }}</div>
          <p class="guarantee-desc" v-html="item.desc"></p>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bottom-section">
      <div class="contact-btn" @click="phone">联系我们：400-086-1123</div>
      <div class="copyright">
        <span>Copyright © 2020 — 2026 东莞市丰派软件科技有限公司</span>
        <div class="copyright-links">
          <span>粤ICP备19023742号</span>
          <div class="gongan">
            <img class="gongan-icon" v-lazy="require('@/assets/help/footer-badge.png')" alt="" />
            <span>粤公网安备4419000206124号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceList: [
        {
          icon: require("@/assets/help/icon-service.svg"),
          title: "专业客服支持",
          desc: "专业客服团队，快速响应商户问题<br />多渠道接入，7x12小时在线服务",
        },
        {
          icon: require("@/assets/help/icon-maintain.svg"),
          title: "技术运维服务",
          desc: "系统实施监控，保障稳定运行<br />专业运维团队，快速定位解决问题",
        },
        {
          icon: require("@/assets/help/icon-upgrade.svg"),
          title: "系统升级维护",
          desc: "持续功能更新，强化产品体验<br />定期系统维护，确保最佳性能",
        },
        {
          icon: require("@/assets/help/icon-security.svg"),
          title: "安全保障",
          desc: "多维安全防护，保障数据安全<br />严格权限管理，保护商户隐私",
        },
      ],
      flowSteps: [
        { num: "01", icon: require("@/assets/help/h5-step-01.svg"), title: "提交问题" },
        { num: "02", icon: require("@/assets/help/h5-step-02.svg"), title: "技术受理" },
        { num: "03", icon: require("@/assets/help/h5-step-03.svg"), title: "问题分析" },
        { num: "04", icon: require("@/assets/help/h5-step-04.svg"), title: "解决处理" },
        { num: "05", icon: require("@/assets/help/h5-step-05.svg"), title: "反馈结果" },
      ],
      guaranteeList: [
        {
          icon: require("@/assets/help/icon-guarantee-stable.svg"),
          value: "99.99%",
          label: "系统稳定性",
          desc: "高可用架构<br />保障系统稳定运行",
        },
        {
          icon: require("@/assets/help/icon-guarantee-exp.svg"),
          value: "10000+",
          label: "商户服务经验",
          desc: "为1w+商户提供优质服务",
        },
        {
          icon: require("@/assets/help/icon-guarantee-hour.svg"),
          value: "7x12h",
          label: "小时支持",
          desc: "每天9:00-21:00<br />专业技术支持",
        },
        {
          icon: require("@/assets/help/icon-guarantee-response.svg"),
          value: "<3min",
          label: "平均响应时间",
          desc: "快速响应<br />及时解决问题",
        },
      ],
    };
  },
  activated() {
    this.$refs.supportH5.scrollIntoView();
  },
  methods: {
    phone() {
      window.location.href = "tel:400-086-1123";
    },
  },
};
</script>

<style lang="less" scoped>
.supportH5 {
  background: #f5f7fa;
  width: 750px;
  margin: 0 auto;

  /* Hero Section */
  .hero-section {
    position: relative;
    width: 100%;
    height: 560px;
    overflow: hidden;

    .hero-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .hero-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 32px;
      box-sizing: border-box;
    }

    .hero-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 500;
      font-size: 56px;
      line-height: 1.2em;
      color: #04154a;
      margin: 0 0 16px;
      text-align: center;
    }

    .hero-subtitle {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 28px;
      line-height: 1.43em;
      color: #69717e;
      margin: 0 0 32px;
      text-align: center;
    }

    .hero-features {
      display: flex;
      justify-content: center;
      gap: 80px;
      margin-top: 20px;
    }

    .feature-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: "Noto Sans SC", sans-serif;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4em;
      color: #002864;

      .feature-icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  /* Common Section */
  .section {
    padding: 40px 32px;

    .section-header {
      text-align: center;
      margin-bottom: 32px;
    }

    .section-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 500;
      font-size: 40px;
      line-height: 1.2em;
      color: #04154a;
      margin: 0 0 12px;
    }

    .section-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 28px;
      line-height: 1.43em;
      color: #3d485d;
      margin: 0;
      text-align: center;
    }
  }

  /* Service Section - 2x2 Grid */
  .service-section {
    .service-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
    }

    .service-card {
      width: calc(50% - 12px);
      background: #fff;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      box-sizing: border-box;

      .service-icon {
        width: 120px;
        height: 120px;
        border-radius: 80px;
        margin-bottom: 24px;
      }

      .service-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .service-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 36px;
        line-height: 1.33em;
        color: #202d40;
        margin: 0;
      }

      .service-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.67em;
        color: #69717e;
        margin: 0;
      }
    }
  }

  /* Support Section - Vertical Stack */
  .support-section {
    .support-cards {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .support-card {
      border-radius: 8px;
      padding: 24px 16px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      display: flex;
      gap: 16px;

      .support-icon {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        flex-shrink: 0;
      }

      .support-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
      }

      .support-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 32px;
        line-height: 1.25em;
        margin: 0;

        &.green {
          color: #09bb07;
        }
        &.purple {
          color: #907fff;
        }
        &.blue {
          color: #336fff;
        }
      }

      .support-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.5em;
        color: #69717e;
        margin: 0;
      }

      .support-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        height: 36px;
        border-radius: 6px;
        font-family: "Noto Sans SC", sans-serif;
        font-size: 24px;
        line-height: 1em;
        padding: 0 16px;

        &.green-btn {
          background: rgba(9, 187, 7, 0.1);
          border: 1px solid #09bb07;
          color: #09bb07;
        }
      }

      .support-tag {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 28px;
        line-height: 1.29em;

        &.purple-tag {
          color: #907fff;
        }
        &.blue-tag {
          color: #336fff;
        }
      }
    }

    .wechat-card {
      background: #eaf9f7;
    }

    .ticket-card {
      background: #f3f2ff;
    }

    .phone-card {
      background: #e6f1ff;
    }
  }

  /* Flow Section - Horizontal */
  .flow-section {
    .flow-steps {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
    }

    .flow-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .step-icon {
        width: 64px;
        height: 64px;
      }

      .step-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.33em;
        color: #202d40;
        white-space: nowrap;
      }
    }

    .step-arrow {
      width: 36px;
      height: 72px;
      margin: 0 8px;
      align-self: flex-end;
      padding-bottom: 32px;
    }
  }

  /* Guarantee Section - 2x2 Grid */
  .guarantee-section {
    .guarantee-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
    }

    .guarantee-card {
      width: calc(50% - 12px);
      background: #fff;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      box-sizing: border-box;

      .guarantee-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
      }

      .guarantee-icon {
        width: 80px;
        height: 80px;
        border-radius: 80px;
      }

      .guarantee-value {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 700;
        font-size: 40px;
        line-height: 1.4em;
        color: #336fff;
      }

      .guarantee-label {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 32px;
        line-height: 1.25em;
        color: #202d40;
        margin-bottom: 16px;
      }

      .guarantee-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 26px;
        line-height: 1.38em;
        color: #69717e;
        margin: 0;
      }
    }
  }

  /* Bottom Section */
  .bottom-section {
    background: #f5f7fa;
    padding: 64px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;

    .contact-btn {
      width: 640px;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%);
      border: 4px solid #fff;
      border-radius: 4px;
      box-shadow: 8px 8px 20px rgba(11, 39, 84, 0.1);
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 32px;
      line-height: 1.25em;
      color: #292929;
      cursor: pointer;
    }

    .copyright {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      span {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.33em;
        color: #3d485d;
      }

      .copyright-links {
        display: flex;
        gap: 20px;
        align-items: center;

        .gongan {
          display: flex;
          align-items: center;
          gap: 4px;

          .gongan-icon {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/supportH5.vue